import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { V2TopBarComponent } from './v2-top-bar.component';
import { PictureViewerModule } from '../picture-viewer/picture-viewer.module';
import { CameraService } from '../../../../services/camera.service';
import { SideCartModule } from '../side-cart/side-cart.module';


@NgModule({
  declarations: [V2TopBarComponent],
  imports: [
    CommonModule,
    IonicModule,
    RouterModule,
    PictureViewerModule,
    SideCartModule
  ],
  providers: [
    CameraService
  ],
  exports: [V2TopBarComponent]
})
export class V2TopBarModule { }
